angular.module('client-bills', [])
    .service('Bills', Bills);

Bills.$inject = ['$rootScope', '$q', '$timeout', 'PortalApi', 'Authentication'];

function Bills($rootScope, $q, $timeout, PortalApi, Authentication) {
    $rootScope.unpaidBillsMonth = 0;
    var BigNumber = require('bignumber.js');
    var bills = {
        bills: [],
        subscribes: [],
        unpaidBillsMonth: 0,
        initList: function () {
            var count = 0;
            var nowMonth = (new Date()).getMonth();

            if (bills.bills.length) {
                bills.bills = bills.bills.map(function (bill) {

                    if (!bill.processed && (new Date(bill.createDate)).getMonth() == nowMonth) {
                        count++;
                    }

                    bill.sum = new BigNumber(bill.amount).plus(bill.debt).toFixed(2);

                    return bill;
                });
            }

            bills.unpaidBillsMonth = count;
        },
        getBills: function (data, force) {
            var defer = $q.defer();
            force = !!force;
            data = data || {};
            
            if (!Authentication.isLogged) {
                defer.reject('');
            }

            if (this.bills.length && !force) {
                defer.resolve(bills.bills);
            } else {
                data.limit = data.limit || 30;
                data.offset = data.offset || 0;

                PortalApi.getBills(data).then(function(response) {
                    bills.bills = response.plain();
                    bills.initList();
                    defer.resolve(bills.bills);
                }, function (reason) {
                    defer.reject('');
                });
            }

            return defer.promise;
        },
        getSubscribers: function (data, force) {
            var defer = $q.defer();
            force = !!force;
            data = data || {};
            data.onlyActive = !!data.onlyActive;

            if (!Authentication.isLogged) {
                defer.reject('');
            }

            if (this.bills.length && !force) {
                defer.resolve(bills.subscribes);
            } else {
                PortalApi.getSubscribers(data).then(function(response) {
                    bills.subscribes = response.plain();
                    defer.resolve(bills.subscribes);
                }, function (reason) {
                    defer.reject('');
                });
            }

            return defer.promise;
        },
        changeSubscribeStatus: function (data) {
            var defer = $q.defer();

            if (!Authentication.isLogged) {
                defer.reject('');
            }

            PortalApi.changeSubscribeStatus(data).then(function(response) {
                defer.resolve(response);
            }, function (reason) {
                defer.reject(reason);
            });

            return defer.promise;
        }
    };

    // $rootScope.$on('logout', function () {
        // bills.bills = [];
        // bills.subscribes = [];
        // bills.unpaidBillsMonth = 0;
    // });

    // $rootScope.$on('login', function () {
        // bills.getBills();
    // });

    return bills;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/client-bills/services/client-bills.js
 ** module id = 74
 ** module chunks = 1
 **/